import { create } from 'zustand';

export enum PodSchedulingValues {
  /** 默认规则 */
  DEFAULT = 'default',
  /** 分散调度 */
  DECENTRALIZED = 'decentralized',
  /** 集中调度 */
  AGGREGATION = 'aggregation',
  /** 自定义调度 */
  CUSTOM = 'custom',
}

/** 自定义规则的类型值枚举 */
export enum PodSchedulingCustomTypes {
  /** 尽可能匹配 (集中调度和分散调度都是这个) */
  PREFERRED_DURING_SCHEDULING_IGNORED_DURING_EXECUTION = 'preferredDuringSchedulingIgnoredDuringExecution',
  /** 必须匹配 */
  REQUIRED_DURING_SCHEDULING_IGNORED_DURING_EXECUTION = 'requiredDuringSchedulingIgnoredDuringExecution',
}

/** 自定义规则的策略值枚举 */
export enum PodSchedulingCustomPolicy {
  /** 与目标调度到一起 */
  POD_AFFINITY = 'podAffinity',
  /** 远离目标调度 */
  POD_ANTI_AFFINITY = 'podAntiAffinity',
}
/** 自定义规则的目标 - 请求的部署列表? */

export interface PodSchedulingCustomItem {
  /** 目标 */
  target: string;
  /** 类型 */
  type: PodSchedulingCustomTypes;
  /** 策略 */
  policy: PodSchedulingCustomPolicy;
}

interface PodSchedulingRulesState {
  selectedPodSchedulingRule: PodSchedulingValues;
  customMode?: PodSchedulingCustomItem[];
}

const initialState: PodSchedulingRulesState = {
  selectedPodSchedulingRule: PodSchedulingValues.DEFAULT,
  customMode: [],
};

interface PodSchedulingRulesAction {
  updateSelectedPodSchedulingRule: (rule: PodSchedulingValues) => void;
  updateCustomMode: (customMode: PodSchedulingCustomItem[]) => void;
  reset: () => void;
}

export const usePodSchedulingRulesStore = create<
  PodSchedulingRulesState & PodSchedulingRulesAction
>()((set) => ({
  ...initialState,
  updateSelectedPodSchedulingRule: (rule) => set({ selectedPodSchedulingRule: rule }),
  updateCustomMode: (customMode) => set({ customMode }),
  reset: () => set(initialState),
}));
